const properties = {
    appVersion : "3.1.0.1"
};

export default properties
